export default "__VITE_ASSET__qYQIpnYY__"